import {
  createBrowserRouter,
  Navigate,
  Outlet
} from "react-router-dom";

import Reports from "./Reports/Reports";
import Corporations from "./Corporations/Corporations";
import Labels from "./Labels/Labels";
import { Stack, Box, Divider } from "@mui/material";
import Sidebar from "../Layout/Sidebar";
import LineItems from "./LineItems/LineItems";
import { API_URL } from "../helpers/variables";
import Tools from "./Tools/Tools";
import FileQueue from "./FileQueue/FileQueue";

const ENV = import.meta.env;

const userKey = ENV.VITE_USER_KEY;
const adminKey = ENV.VITE_ADMIN_KEY;

function Layout() {
  return (
    <Stack height={"100%"} direction={"row"}>
      <Sidebar />
      <Divider orientation="vertical" flexItem />
      <Box flexGrow={1} height={"100%"} overflow={"auto"}>
        <Outlet />
      </Box>
    </Stack>
  );
}

const router = createBrowserRouter([
  {
    id: "authentication-context",
    path: "/",
    loader: async ({ request }) => {
      const url = new URL(request.url);
      let authID = url.searchParams.get("authID");
      let merge = url.searchParams.get("merge");

      if (!authID) {
        authID = prompt("authID:");
        if (!authID) throw new Error("authID is required");
        url.searchParams.set("authID", authID);
        window.location.href = url.toString();
      }

      if (authID === userKey) return { edit: false, authID };
      else if (authID === adminKey)
        return { edit: true, authID, merge: Boolean(merge) };
      else throw new Error("Invalid authID");
    },
    element: <Layout />,
    children: [
      {
        path: "inbox",
        loader: async () => {
          const response = await fetch(`${API_URL}/get_pms`);
          return { PMSList: await response.json() };
        },
        // element: <Sources />,
        element: <FileQueue />,
      },
      {
        path: "reports",
        element: <Reports />,
      },
      {
        path: "corporations",
        element: <Corporations />,
      },
      {
        path: "labels",
        element: <Labels />,
      },
      {
        path: "line_items",
        loader: async () => {
          const response = await fetch(`${API_URL}/get_pms`);
          return { PMSList: await response.json() };
        },
        element: <LineItems />,
      },
      {
        path: "tools",
        loader: async () => {
          const response = await fetch(`${API_URL}/get_pms`);
          return { PMSList: await response.json() };
        },
        element: <Tools />,
      },
      {
        path: "*",
        element: (
          <Navigate
            to={`/inbox?${new URLSearchParams(window.location.search).toString()}`}
            replace
          />
        ),
      },
    ],
  },
]);

export default router;
